import { goto } from '$app/navigation';
import type { TSlotItemSummary } from '$lib/models/services';
import { APXNetworkError } from '$lib/services/core/apex-errors';
import { platform } from '$lib/stores/platformStore';
import cronstrue from 'cronstrue';
import { get } from 'svelte/store';

export const apiErrorHandler = async (error: unknown, message: string = '') => {
	// toastStore.notify({
	// 	kind: 'warning',
	// 	message
	// });
	if (error instanceof APXNetworkError) {
		console.error(message, await error.response.json());
	} else {
		console.error(message, error);
	}
};

/**
 * Handler for redirecting after Login
 */
export const loginRedirectionHandler = async () => {
	const redirectUrl = localStorage.getItem('redirectUrl');
	if (redirectUrl) {
		localStorage.removeItem('redirectUrl');
		await goto(redirectUrl, { replaceState: true });
	} else {
		const _platform = get(platform);
		if (_platform === 'web') {
			await goto('/', { replaceState: true });
		} else {
			await goto('/nudge/home', { replaceState: true });
		}
	}
};

/**
 * Handler for showing and hiding chat loader
 * @param show To show or not to show
 */
export const chatLoadingHandler = (show: boolean) => {
	const chatLoadingEvent = new CustomEvent('inline-loader', { detail: show });
	setTimeout(() => {
		document.dispatchEvent(chatLoadingEvent);
	});
};

export const scrollToBottom = () => {
	window.scrollTo({ left: 0, top: document.body.scrollHeight, behavior: 'smooth' });
};

/**
 * Stops body scrolling when components are displayed
 * @param allowScroll Whether background scroll is allowed or not
 */
export const bodyScrollHandler = (allowScroll: boolean) => {
	if (!allowScroll) {
		document.body.classList.add('overflow-hidden');
		document.body.classList.add('h-screen');
	} else {
		document.body.classList.remove('overflow-hidden');
		document.body.classList.remove('h-screen');
	}
};

const indianPriceFormat = new Intl.NumberFormat('en-IN', {
	style: 'currency',
	currency: 'INR'
});

export const indianPrice = (price: number) => {
	return indianPriceFormat.format(price);
};

export const sortScheduledOrders = (slotItems: TSlotItemSummary[]) => {
	return slotItems
		.map((item) => item.scheduled_orders)
		.flat()
		.sort((a, b) => Number(a.delivery_date) - Number(b.delivery_date));
};

export const cronToString = (cron: string) => {
	return cronstrue.toString(cron.split('Asia/Kolkata')[0]).split('At 01:00 AM, only on ')[1];
};

/**
 * @param value - Takes price input in paisa
 * @param mode - To round off the value or to return fixed decimal value
 * @returns value in rupees
 */
export const paisaToRupeeConversion = (value: number, mode: 'rounded' | 'fixed' = 'rounded') => {
	if (mode === 'rounded') {
		return Math.round(value / 100);
	} else {
		return Number((value / 100).toFixed(2));
	}
};

export const arrayUniqueByKey = <T>(array: Array<T>, key: keyof T) => {
	return [...new Map(array.map((item) => [item[key], item])).values()];
};

export const deepSearchObj = <T>(obj: T, keyToFind: string, valueToFind: string) => {
	let _obj;
	JSON.stringify(obj, (_, nestedValue) => {
		if (nestedValue && nestedValue[keyToFind] === valueToFind) {
			_obj = nestedValue;
		}
		return nestedValue;
	});
	return _obj;
};

export const dispatchCartChange = () => {
	const cartChanged = new CustomEvent('cart_changed');
	document.dispatchEvent(cartChanged);
};

export const clickOutsideToClose = (node: HTMLElement, callback: () => void) => {
	const handleClick = (event: MouseEvent) => {
		if (!node.contains(event.target as Node)) {
			callback();
		}
	};

	document.addEventListener('click', handleClick, true);

	return {
		destroy() {
			document.removeEventListener('click', handleClick, true);
		}
	};
};
